import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class UiServiceTokenInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(!request.headers.has('Content-Type')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json; charset=utf-8') });
    }
    if(!request.headers.has('Accept')) {
      request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    }

    request = request.clone({
      withCredentials: true
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return(event);
      }),
      catchError((error: HttpErrorResponse) =>  {
        return throwError(() => error);
      })
    );
  }
}
